import { render, staticRenderFns } from "./TabunganKelompok.vue?vue&type=template&id=0ec4d7fa"
import script from "./TabunganKelompok.vue?vue&type=script&lang=js"
export * from "./TabunganKelompok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports